import { Alert, Autocomplete, Box, CircularProgress, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import marketplacesService from "../../../services/marketplacesService";
import { useDispatch, useSelector } from "react-redux";
import { fetchcategoryAttribute } from "../../../redux/actions/outWard";

const AddCategoryAttribute = ({ selectedPlacesCategory, marketPlaceName,
    setSelectedAttributes, setAllAttribute, loadingSend, selectedPlatformType }) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [allAccounts, setAllAccounts] = useState([]);
    const [outWardCategoryAttribute, setOutWardCategoryAttribute] = useState(null);
    const userId = useSelector((state) => state?.auth?.user?.id);
    const token = useSelector(state => state?.auth?.user?.accessToken?.token);
    const [accountMarketpleacesName, setAccountMarketpleacesName] = useState({});
    const dispatch = useDispatch();
    useEffect(() => {
        const fetchAccounts = async () => {
            setLoading(true);
            try {
                const response = await marketplacesService.getMarketPlacesAccountsApi(
                    userId,
                    token
                );
                setAllAccounts(response?.data?.data?.data);
                const uniqueMarketPlaceNames = [...new Set(response?.data?.data?.data.map(item => item?.marketPlaceName))];
                setAccountMarketpleacesName(uniqueMarketPlaceNames);
                setLoading(false);
            } catch (err) {
                setError(
                    err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
                );
                setLoading(false);
            }

        };
        fetchAccounts();
        setSelectedAttributes([])
    }, []);


    const getCategoryAttribute = async () => {
        setOutWardCategoryAttribute(null);
        const categoryId = selectedPlacesCategory?.marketPlaceCategoryId;

        if (marketPlaceName == null) {
            return;
        }
        if (categoryId == null) {
            return;
        }

        const requestBody = createRequestBodyAttribute(
            categoryId,
            marketPlaceName,
            allAccounts,
            "2024-11-01T13:17:58.526Z",
            "2024-11-16T13:17:58.526Z"
        );
        try {
            setLoading(true);
            await dispatch(fetchcategoryAttribute(marketPlaceName, requestBody, token));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("API Hatası:", error.response ? error.response.data : error.message);

        }
        finally {
            setLoading(false);
        }
    }

    const createRequestBodyAttribute = (categoryId, selectedPlaceName, allAccounts, startDate, endDate, page = 0, size = 100) => {
        const marketPlaceSettings = allAccounts
            .filter(account => account.marketPlaceName === selectedPlaceName)
            .map(account => ({
                id: 0,
                userId: account.userId,
                marketPlaceId: account.marketPlaceId || 0,
                marketPlaceName: account.marketPlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));

        const ecommercePlaceSettings = [
            {
                id: 0,
                userId: 0,
                ecommerceId: 0,
                value: "string",
                valueId: "string",
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            },
        ];

        return {
            categoriId: categoryId,
            userId: userId,
            marketPlaceSetting: marketPlaceSettings,
            ecommercePlaceSettings: ecommercePlaceSettings,
            startDate: startDate || new Date().toISOString(),
            endDate: endDate || new Date().toISOString(),
            page: page,
            size: size,
        };
    };

    const categoryVariant = useSelector((state) => state?.outWardCategoryAttribute || []);

    useEffect(() => {
        if (categoryVariant?.outWardCategoryAttribute?.length > 0) {

            const filteredAttributes = categoryVariant?.outWardCategoryAttribute.map(item => item);
            setOutWardCategoryAttribute(filteredAttributes);
        }
        setAllAttribute(categoryVariant?.outWardCategoryAttribute);

    }, [categoryVariant]);

    useEffect(() => {
        if (allAccounts?.length > 0) {
            setOutWardCategoryAttribute(null);
            getCategoryAttribute();
        }

    }, [allAccounts])
    const updatedAttributes = outWardCategoryAttribute?.map((item) => ({
        ...item,
        attribute: { ...item.attribute, varianter: item.varianter },
    }));
    const handleSelect = (attribute, value) => {
        if (value) {
            if (typeof value === 'object') {
                setSelectedAttributes((prev) => [
                    ...prev.filter((item) => item.attribute.id !== attribute.id),
                    { attribute, value },
                ]);
            }
            else {
                setSelectedAttributes((prev) => [
                    ...prev.filter((item) => item.attribute.id !== attribute.id),
                    { attribute, value },
                ]);
            }
        } else {
            setSelectedAttributes((prev) =>
                prev.filter((item) => item.attribute.id !== attribute.id)
            );
        }
    };
   
    return (
        <Box>



            {

                loading || loadingSend ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100vh"
                        width="100%"
                    >
                        <CircularProgress />
                    </Box>
                ) :


                    selectedPlatformType == "ecommerce" || marketPlaceName == "Pttavm" ?
                        <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                            Seçilen pazaryeri için özellik seçimi gerekli değil
                        </Alert>

                        :
                        !accountMarketpleacesName?.includes(marketPlaceName) ? (
                            <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                                Seçilen pazaryeri için ayarlar eksik. Lütfen{" "}
                                <a
                                    href="/Profile"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        color: "blue",
                                    }}
                                >
                                    profil
                                </a>{" "}
                                alanından gerekli bilgileri doldurunuz.
                            </Alert>
                        ) :


                            outWardCategoryAttribute ? (
                                <Stack spacing={2}>

                                    <Alert severity="info" sx={{ width: '100%', mb: 2 }}>
                                        Ürün varyantları xml den geldi veya manuel olarak oluşturdu iseniz buradan varyant seçmemelisiniz
                                    </Alert>
                                    {updatedAttributes
                                        ?.sort((a, b) => b.required - a.required)
                                        ?.map(
                                            (item) =>
                                                item?.attributeValues?.length > 0 && (
                                                    <Autocomplete
                                                        key={item?.attribute?.id}
                                                        disablePortal
                                                        options={item?.attributeValues || []}
                                                        getOptionLabel={(option) => option.name || ''}
                                                        onChange={(event, value) => handleSelect(item.attribute, value)}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const filteredOptions = options.filter(option =>
                                                                option.name.toLowerCase().includes(inputValue.toLowerCase())
                                                            );
                                                            return filteredOptions.slice(0, 10);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={
                                                                    item.required
                                                                        ? `${item?.attribute?.name} (${item?.attribute?.varianter ? 'Varianter' : ''})`
                                                                        : item?.attribute?.name
                                                                }
                                                                required={item.required}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: item.required ? 'red' : 'inherit',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )
                                        )}

                                    {updatedAttributes.map((item) => (
                                        item?.attributeValues?.length === 0 && (
                                            <TextField
                                                key={item?.attribute?.name}
                                                id="outlined-basic"
                                                label={
                                                    item.required
                                                        ? `${item?.attribute?.name} * (${item?.attribute?.varianter ? 'Varianter' : ''})`
                                                        : item?.attribute?.name
                                                }
                                                variant="outlined"
                                                required={item.required}
                                                InputLabelProps={{
                                                    style: {
                                                        color: item.required ? 'red' : null,
                                                    },
                                                }}
                                                sx={{
                                                    width: '100%',
                                                }}
                                                onChange={(e) => handleSelect(item.attribute, e.target.value)}
                                            />
                                        )
                                    ))}
                                </Stack>
                            ) : (
                                <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                                    Seçilen pazaryerinde ürününüze ait kategori eşleşmiyor.
                                    Kategori sayfasından eşleştirme yapınız.
                                </Alert>
                            )}
        </Box>
    );
}
export default AddCategoryAttribute;